// extracted by mini-css-extract-plugin
export var csatScore = "_k7-5";
export var header = "_k7-1";
export var panelWrapper = "_k7-2";
export var postPreview = "_k7-3";
export var rightContent = "_k7-0";
export var wrappingText = "_k7-4";